import { MdBuild, MdPauseCircleOutline } from "react-icons/md";

export const DEFAULT_MAINTENANCE_MESSAGE =
  "The trader site is in maintenance right now. Your partner portal keeps working, but traders cannot place orders until maintenance ends.";

export const DEFAULT_MARKET_CREATION_PAUSED_MESSAGE =
  "Creating new markets is paused for now. Your existing markets keep trading as normal — please check back later.";

export function MaintenanceBanner({ message }) {
  return (
    <div
      role="status"
      className="mb-4 flex items-start gap-3 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-800 dark:border-amber-400/30 dark:bg-amber-400/10 dark:text-amber-200"
    >
      <MdBuild className="mt-0.5 shrink-0 text-lg" aria-hidden="true" />
      <div className="min-w-0">
        <p className="font-semibold">Maintenance in progress</p>
        <p className="mt-0.5 break-words">{message || DEFAULT_MAINTENANCE_MESSAGE}</p>
      </div>
    </div>
  );
}

export function PausedNotice({ title = "Market creation is paused", message, children }) {
  return (
    <div
      role="status"
      className="flex items-start gap-3 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-800 dark:border-amber-400/30 dark:bg-amber-400/10 dark:text-amber-200"
    >
      <MdPauseCircleOutline className="mt-0.5 shrink-0 text-lg" aria-hidden="true" />
      <div className="min-w-0 flex-1">
        <p className="font-semibold">{title}</p>
        <p className="mt-0.5 break-words">{message || DEFAULT_MARKET_CREATION_PAUSED_MESSAGE}</p>
        {children}
      </div>
    </div>
  );
}
